import type {
  ForkStatus,
  Task,
  UnpausedForkStatus,
} from "@gearbox-protocol/deploy-tools-shared";
import type { NavBarItem } from "components/NavBar";
import { isAfter } from "date-fns";
import { useMemo } from "react";

export default function useForkNav(f: ForkStatus): NavBarItem[] {
  return useMemo<NavBarItem[]>(() => {
    if (f.paused) {
      return [{ title: "Status", path: "status" }];
    }
    const fork = f as UnpausedForkStatus;
    // for each task definition id, find task with latest createdAt date
    const tasksByDef: Record<string, Task> = {};
    for (const t of fork.tasks ?? []) {
      if (!tasksByDef[t.definitionId]) {
        tasksByDef[t.definitionId] = t;
      } else if (isAfter(t.createdAt, tasksByDef[t.definitionId].createdAt)) {
        tasksByDef[t.definitionId] = t;
      }
    }

    const taskTabs: NavBarItem[] = Object.values(tasksByDef).map(t => ({
      title: t.name ?? t.definitionId,
      path: `tasks/${t.id}`,
    }));

    return [
      { title: "Status", path: "status" },
      { title: "Faucet", path: "faucet" },
      {
        title: "SDK Live",
        path: "sdk",
        disabled: !fork.marketConfigurators?.length,
      },
      {
        title: "Artifacts",
        path: "artifacts",
      },
      ...taskTabs,
      {
        title: "Update",
        path: "update",
        hideEntireBar: true,
      },
    ];
  }, [f]);
}
